import { useState, useEffect, useRef } from "react";
import { Parallax, ParallaxLayer } from "@react-spring/parallax";

function ParallaxImages() {
  const parallax = useRef(null);
  const [rotate, setRotate] = useState(0);
  const PAGES = 3;

  useEffect(() => {
    const handleScroll = (e) => {
      const height = parallax.current.space;
      const scrollablePages = PAGES - 1; // because you can't scroll past the last page
      const scrollHeight = height * scrollablePages;

      const scrollTop = e.target.scrollTop;
      const percentScrolled = scrollTop / scrollHeight;
      const currentPage = Math.floor(percentScrolled * scrollablePages);
      const currentPageScrollTop = scrollTop - height * currentPage;
      const currentPagePercent = currentPageScrollTop / height;

      setRotate(currentPagePercent);
    };

    const container = parallax.current.container.current;
    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Parallax pages={3} ref={parallax}>
        {/* Background Layer */}
        <ParallaxLayer
          offset={0}
          speed={0.2}
          className="flex justify-center items-center h-screen"
        >
          <video
            autoPlay
            loop
            muted
            className="w-[90vw] md:w-[60vw] max-w-[500px] mt-[10vh] md:mt-0"
            style={{ zIndex: 1 }}
          >
            <source src="/Rest_Animation_2.mov" type="video/mp4" />
          </video>
        </ParallaxLayer>

        {/* Foreground Layers */}
        {/* beefhoney */}
        <ParallaxLayer offset={0} speed={0.5} style={{ zIndex: 2 }}>
          <img
            src="/Beef_Honey.jpg"
            alt="Beef Honey Album Cover"
            className="w-[200px] ml-[40%] md:ml-[70%] mt-[150%] md:mt-[10%]"
          />
        </ParallaxLayer>
        {/* remembering thunder */}
        <ParallaxLayer offset={0} speed={2.0} style={{ zIndex: 3 }}>
          <img
            src="/Remembering_Thunder.jpg"
            alt="Remembering Thunder Single Cover"
            className="w-[200px] ml-[15%] mt-[200%] md:mt-[30%]"
          />
        </ParallaxLayer>
        {/* spidersagain */}
        <ParallaxLayer offset={0} speed={20} style={{ zIndex: 3 }}>
          <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="450.000000pt"
            height="282.000000pt"
            viewBox="0 0 450.000000 282.000000"
            preserveAspectRatio="xMidYMid meet"
            className="mt-[100vh] w-full"
          >
            <metadata>
              Created by potrace 1.10, written by Peter Selinger 2001-2011
            </metadata>
            <g
              transform="translate(0.000000,282.000000) scale(0.050000,-0.050000)"
              fill="currentColor"
              stroke="none"
            >
              <path
                d="M948 4763 c6 -10 50 -22 97 -28 47 -6 296 -47 555 -90 259 -44 560
-91 670 -104 573 -67 863 -137 1009 -242 97 -71 96 -73 -72 -144 -158 -67
-459 -253 -605 -375 l-115 -96 -107 169 c-308 490 -926 455 -1750 -97 -234
-157 -266 -203 -150 -211 64 -4 66 -2 22 16 -46 19 -42 24 91 115 485 334 736
440 1090 458 369 20 488 -35 666 -305 l114 -174 -83 -82 c-86 -85 -260 -332
-260 -370 0 -11 -8 -26 -19 -32 -24 -15 -121 30 -121 56 0 11 -6 14 -12 7 -11
-10 -222 96 -248 125 -5 6 -48 36 -95 67 -98 63 -97 65 -113 -131 -27 -344
-386 -817 -1152 -1520 -126 -116 -223 -219 -214 -227 8 -9 35 6 60 33 24 27
197 190 384 363 187 172 357 334 379 359 21 26 93 110 160 187 263 302 410
576 426 794 10 134 31 150 105 76 6 -5 64 -46 130 -90 66 -44 126 -88 134 -99
8 -11 20 -14 27 -6 8 7 39 0 70 -15 l55 -29 -29 -96 c-22 -70 -27 -139 -16
-265 7 -93 14 -189 16 -213 2 -24 9 -39 16 -35 8 5 19 -3 25 -17 7 -14 7 7 1
45 -60 375 -16 595 105 534 31 -15 130 -49 221 -75 201 -57 200 -48 55 -336
-126 -251 -190 -472 -190 -658 l0 -129 -95 11 c-52 6 -187 23 -298 36 l-204
25 -8 121 c-10 154 21 441 57 528 15 37 23 75 17 85 -6 10 -3 18 8 18 19 0 44
96 45 169 0 22 11 47 24 55 18 12 18 15 -1 16 -14 0 -31 0 -38 0 -7 0 -16 -34
-19 -77 -4 -42 -21 -109 -38 -149 -16 -40 -30 -91 -30 -113 0 -23 -8 -41 -17
-41 -34 0 -58 -391 -33 -535 11 -62 9 -65 -49 -65 -73 0 -72 13 -11 -210 38
-138 50 -227 49 -380 -1 -284 -17 -342 -247 -897 -73 -175 -132 -332 -131
-350 1 -50 26 0 147 292 58 140 124 296 147 345 157 346 182 678 77 1009 l-49
153 54 -10 c69 -13 357 -47 528 -63 110 -10 135 -19 135 -47 0 -184 464 -602
668 -602 19 0 53 -12 78 -28 79 -49 427 -97 727 -99 295 -3 363 -19 187 -43
-55 -8 -100 -22 -100 -32 0 -28 56 -21 220 25 83 23 231 48 330 57 804 68
1717 319 2135 586 l109 69 258 -68 c1199 -317 1329 -567 548 -1054 -300 -187
-331 -209 -315 -225 30 -29 706 415 772 507 244 344 -106 609 -1116 845 l-110
26 50 32 c172 111 374 353 441 529 l44 113 107 0 c336 0 911 -419 1227 -895
119 -178 167 -217 98 -80 -239 476 -932 1015 -1306 1015 l-110 0 0 165 c0 93
-15 212 -33 272 -38 127 -36 129 131 173 524 137 1107 -58 1197 -400 12 -44
31 -181 43 -304 21 -226 86 -486 121 -486 25 0 24 12 -12 130 -17 55 -44 217
-61 360 -47 407 -85 484 -313 631 -267 173 -799 207 -1116 71 -22 -10 -43 12
-77 82 -127 263 -411 569 -697 752 -92 59 -97 73 -62 176 55 166 135 187 402
109 58 -17 384 -53 725 -81 341 -28 685 -63 765 -77 149 -26 196 -12 80 24
-118 37 -518 79 -1275 135 -93 7 -237 29 -319 50 -271 69 -373 28 -423 -173
l-22 -87 -81 51 c-672 424 -1808 529 -2643 244 l-178 -61 -58 62 c-129 138
-377 204 -1136 302 -170 22 -449 63 -620 91 -544 90 -650 102 -632 72z m4242
-390 c325 -62 691 -187 960 -329 l140 -74 -7 -100 c-13 -208 -82 -663 -112
-748 -36 -102 -34 -108 37 -91 51 13 73 49 30 49 -14 0 -18 21 -10 55 22 101
93 634 95 719 2 80 4 83 45 62 267 -142 667 -580 741 -812 12 -38 -29 -63
-194 -123 -63 -23 -69 -45 -21 -84 29 -24 32 -23 20 8 -8 24 -3 35 17 35 17 0
66 18 109 40 43 22 86 40 96 40 30 0 64 -197 64 -372 l0 -168 -87 0 c-211 0
-911 -184 -1010 -266 -19 -16 -30 -15 -42 4 -12 20 -22 18 -43 -11 -16 -20
-68 -70 -118 -110 -49 -40 -118 -98 -153 -130 -92 -84 -169 -147 -180 -147 -9
0 -167 -114 -221 -160 -13 -11 -29 -20 -35 -20 -6 0 -58 -31 -117 -68 -171
-110 -589 -322 -786 -400 -364 -144 -1239 -74 -1410 112 -97 107 -296 496
-253 496 3 0 72 -18 153 -41 81 -22 152 -36 158 -30 24 24 -71 68 -174 81
-150 19 -159 24 -182 110 -72 267 -115 953 -64 1004 28 28 407 -85 469 -139
32 -28 35 -28 35 1 0 42 -68 77 -287 145 -97 30 -168 60 -157 67 10 7 42 46
70 88 163 241 491 564 553 544 34 -10 67 21 156 145 51 72 56 88 20 74 -19 -7
-23 20 -18 108 4 74 -5 144 -25 191 -23 56 -25 76 -6 83 192 73 588 168 814
196 146 19 775 -5 930 -34z m-1772 -256 c24 -70 29 -201 10 -289 -9 -40 -52
-89 -142 -158 -154 -119 -437 -414 -552 -575 -79 -111 -133 -153 -104 -80 29
72 37 197 11 172 -13 -12 -29 -60 -35 -106 -11 -79 -15 -83 -64 -71 -145 35
-382 114 -392 131 -17 27 70 166 209 336 l120 147 33 -77 c54 -127 61 -137 95
-143 49 -10 40 28 -29 128 -34 50 -57 102 -51 117 32 83 740 526 846 530 13 1
33 -27 45 -62z m-841 -1602 c6 -202 58 -572 93 -658 11 -29 4 -31 -64 -16 -42
10 -109 18 -149 19 -124 0 -137 13 -137 130 0 132 81 447 149 580 28 55 51
111 51 123 0 13 11 28 25 34 14 5 25 10 25 11 0 1 3 -99 7 -223z m4603 -83 c0
-116 -244 -432 -462 -597 -78 -60 -257 -37 -285 35 -13 34 -64 40 -83 9 -21
-33 74 -95 169 -109 l90 -14 -80 -49 c-378 -235 -1084 -447 -1866 -558 -287
-41 -288 -39 -4 88 130 58 310 150 401 204 92 55 170 99 174 99 43 0 673 492
682 533 4 15 19 27 35 27 15 0 38 19 50 42 12 23 34 36 50 30 15 -5 78 12 139
39 284 126 990 283 990 221z m-4643 -619 l148 -23 44 -122 c49 -138 150 -310
228 -395 l53 -56 -90 35 c-119 47 -176 83 -260 169 -38 40 -89 85 -111 100
-23 16 -63 58 -88 93 -26 36 -54 60 -62 55 -9 -5 -29 31 -46 81 -36 105 -48
101 184 63z"
              />
              <path
                d="M6440 3637 c0 -23 61 -157 71 -157 18 0 -16 110 -43 139 -16 16 -28
24 -28 18z"
              />
              <path
                d="M6511 3413 c6 -25 14 -74 16 -109 3 -35 13 -70 22 -78 12 -12 7 122
-8 229 -1 3 -10 5 -21 5 -12 0 -16 -21 -9 -47z"
              />
              <path
                d="M4560 3350 c-35 -43 -9 -103 30 -70 33 28 39 72 12 89 -9 6 -28 -3
-42 -19z"
              />
              <path
                d="M6536 3180 c-6 -16 -21 -87 -33 -157 -12 -69 -57 -200 -100 -290 -73
-149 -115 -214 -247 -381 -75 -95 -91 -129 -45 -92 22 17 51 46 66 66 14 19
42 51 61 70 108 106 261 402 301 584 24 106 21 263 -3 200z"
              />
              <path
                d="M5300 3015 c1 -64 33 -110 59 -84 15 15 13 38 -4 75 -30 66 -55 70
-55 9z"
              />
              <path
                d="M3738 2951 c-18 -18 22 -400 55 -514 100 -360 481 -502 1067 -399
397 70 755 267 713 392 -10 33 -73 36 -73 4 0 -281 -952 -496 -1381 -312 -220
95 -319 294 -319 644 0 183 -16 231 -62 185z"
              />
              <path
                d="M2135 3556 c-37 -47 -45 -76 -20 -76 8 0 30 27 49 60 40 70 22 79
-29 16z"
              />
              <path
                d="M3520 976 c0 -9 72 -16 160 -16 100 0 160 8 160 21 0 14 -56 20 -160
16 -88 -3 -160 -12 -160 -21z"
              />
            </g>
          </svg>
        </ParallaxLayer>
        {/* spider */}
        <ParallaxLayer offset={0} speed={-10} style={{ zIndex: 3 }}>
          <svg
            height="80px"
            width="80px"
            version="1.1"
            id="_x32_"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            className="mt-[-40%] ml-[60%]"
            fill="currentColor"
          >
            <g>
              <path
                className="st0"
                d="M151.633,329.521c-8.238,0-14.89,6.668-14.89,14.898c0,8.223,6.651,14.882,14.89,14.882
		c8.223,0,14.89-6.659,14.89-14.882C166.523,336.188,159.855,329.521,151.633,329.521z"
              />
              <path
                className="st0"
                d="M229.257,346.783c-8.222,0-14.89,6.66-14.89,14.882c0,8.23,6.668,14.898,14.89,14.898
		c8.223,0,14.891-6.668,14.891-14.898C244.148,353.442,237.48,346.783,229.257,346.783z"
              />
              <path
                className="st0"
                d="M438.457,224.151c0,0,0,0,0,0.008c0.016,0,0.016,0,0.016,0L438.457,224.151z"
              />
              <path
                className="st0"
                d="M438.297,224.063l0.16,0.088c0,0,0-0.008-0.016-0.008L438.297,224.063z"
              />
              <path
                className="st0"
                d="M456.2,166.746c0,0,0,0,0,0.008h0.016L456.2,166.746z"
              />
              <path
                className="st0"
                d="M456.04,166.65l0.16,0.096c0,0,0-0.008-0.015-0.008L456.04,166.65z"
              />
              <path
                className="st0"
                d="M487.102,241.342c12.854,1.418,23.978-3.775,24.844-11.629c0.865-7.854-8.832-15.371-21.67-16.798
		c-3.687-0.409-7.18-0.224-10.387,0.36l-13.832-30.934l-0.176-0.296c-0.513-0.858-1.298-3.198-2.404-5.971
		c-0.577-1.394-1.282-2.941-2.372-4.576c-1.074-1.618-2.613-3.406-4.905-4.744c-3.093-1.819-6.572-2.724-10.033-2.724
		c-3.318,0-6.652,0.833-9.633,2.5l-0.449,0.24l-30.308,22.094c-4.328-37.658-27.537-68.84-70.348-79.283
		c-48.534-11.837-94.742,2.724-129.46,31.872l-5.417-59.665l-0.625-1.314c-2.997-6.227-8.992-10.05-15.579-10.867
		c-0.85-0.104-1.715-0.152-2.565-0.152c-5.722,0.016-11.284,2.259-15.243,6.66l-0.209,0.232l-14.826,19.258
		c-3.174-0.778-6.78-1.162-10.626-0.938c-11.877,0.706-21.19,6.484-20.82,12.895c0.384,6.436,10.306,11.067,22.182,10.379
		c6.524-0.385,12.214-2.332,16.012-5.041l0.401,0.321l1.138-1.467c1.026-0.937,1.763-1.963,2.324-3.013l16.717-21.726
		c0.513-0.577,1.651-1.162,2.949-1.146l0.577,0.032c1.058,0.12,1.715,0.552,2.18,0.986l6.267,69.041
		c-9.344,10.065-17.502,21.285-24.235,33.362l-32.537-59.048l-0.064,0.032c-2.853-6.042-8.495-10.314-15.146-11.236
		c-0.898-0.12-1.796-0.184-2.709-0.184c-6.027,0-11.765,2.748-15.547,7.541l-0.193,0.232l-14.57,21.382
		c-4.055-1.787-8.976-2.86-14.345-2.86c-13.608,0-24.62,6.732-24.62,15.042c0,8.31,11.012,15.042,24.62,15.042
		c12.197,0,22.247-5.433,24.202-12.55l17.839-26.158c0.658-0.802,1.604-1.258,2.613-1.258l0.464,0.032
		c1.218,0.168,2.228,0.954,2.709,2.076l0.161,0.4l38.355,69.635c-3.526,8.567-6.348,17.438-8.415,26.518l-46.097-47.347
		l-0.032,0.032c-3.767-4.087-9.024-6.436-14.553-6.443l-1.283,0.048l0,0c-0.016,0-0.016,0-0.032,0l-0.096,0.008v0.016
		c-6.075,0.416-11.636,3.598-15.05,8.663l-34.364,50.818c-4.12-1.451-9.056-2.156-14.345-1.788
		c-13.56,0.938-24.091,8.415-23.514,16.71c0.577,8.294,12.037,14.241,25.613,13.295c6.155-0.425,11.62-2.244,15.772-4.833
		l0.32,0.225l0.481-0.697c4.056-2.741,6.54-6.291,6.812-10.082l36.817-54.464c0.61-0.882,1.571-1.427,2.613-1.491l0.064-0.008h0.048
		l0.144-0.007c0.961,0,1.891,0.424,2.548,1.154l0.128,0.152l54.72,56.203c-0.577,6.019-0.817,12.093-0.689,18.208l-21.366-18.568
		l-0.016,0.024c-5.257-4.888-11.988-7.382-18.672-7.373c-7.005-0.008-14.074,2.7-19.394,8.038l-0.434,0.432l-42.394,57.549
		c-3.414-1.09-7.228-1.763-11.348-1.763c-13.608,0-24.619,6.732-24.619,15.042c0,8.311,11.011,15.042,24.619,15.042
		c13.592,0,24.619-6.732,24.619-15.042c0-1.009-0.176-1.996-0.496-2.949l41.865-56.852c2.148-2.044,4.825-3.078,7.582-3.086
		c2.772,0.008,5.465,1.002,7.628,3.062l0.161,0.152l32.136,27.929c-25.132,3.19-44.526,24.523-44.526,50.513
		c0,28.065,22.728,50.882,50.873,50.882c12.15,0,23.306-4.272,32.008-11.412c8.127,16.99,25.436,28.642,45.632,28.642
		c27.808,0,50.424-22.415,50.825-50.136l0.064,0.104c4.088-1.57,8.046-3.261,11.925-5.008l72.287-13.456l0.609-0.224
		c1.266-0.449,2.516-0.657,3.75-0.657c4.312,0.008,8.366,2.589,10.13,6.78l15.884,71.887c-0.513,1.05-0.881,2.148-0.994,3.31
		c-0.754,8.27,9.601,15.98,23.161,17.214c13.544,1.242,25.132-4.463,25.886-12.742c0.753-8.27-9.601-15.98-23.161-17.215
		c-3.558-0.328-6.956-0.152-10.082,0.402l-15.002-67.903l-0.225-0.578c-4.199-10.867-14.569-17.575-25.597-17.566
		c-2.677,0-5.385,0.472-8.03,1.29v-0.008l-26.928,5.008c5.29-3.942,10.387-8.014,15.099-12.293l54.896-29.948l1.651-0.425
		l1.362,0.281c0.978,0.432,1.7,1.282,1.956,2.316l16.702,66.317c-0.304,0.713-0.61,1.434-0.738,2.212
		c-1.314,8.198,8.479,16.598,21.91,18.761c13.432,2.164,25.372-2.733,26.703-10.939c1.315-8.206-8.494-16.597-21.91-18.761
		c-3.975-0.641-7.773-0.593-11.252-0.096l-15.498-61.5c-1.491-5.955-5.658-10.875-11.284-13.336
		c-2.532-1.114-5.258-1.667-7.95-1.667c-3.286,0-6.555,0.818-9.504,2.428l-16.445,8.968c4.696-7.029,8.768-14.21,12.246-21.478
		l35.197-25.661l1.507-0.392l1.186,0.32c0.224,0.377,0.513,0.898,0.818,1.563c0.866,1.843,1.843,4.464,2.756,7.092
		c0.93,2.645,1.779,5.282,2.613,7.525l-0.016-0.024l16.221,44.014c0.786,7.204,9.392,14.361,21.061,16.862
		c13.287,2.852,25.485-1.411,27.232-9.537c1.73-8.127-7.614-17.022-20.918-19.875c-5.225-1.13-10.274-1.115-14.585-0.232
		l-13.608-36.905v-0.024c-0.994-2.621-2.436-7.285-4.135-11.693c-0.866-2.228-1.796-4.416-2.95-6.499
		c-0.593-1.05-1.234-2.076-2.068-3.126c-0.849-1.026-1.875-2.139-3.574-3.15c-3.094-1.819-6.572-2.733-10.034-2.724
		c-3.318,0-6.652,0.833-9.633,2.5l-0.449,0.24L401.993,236.1c2.421-9.208,3.831-18.36,4.328-27.32l38.34-27.945l1.506-0.392
		l1.394,0.377c0.272,0.424,0.754,1.434,1.298,2.925c0.592,1.547,1.282,3.47,2.356,5.602l-0.016,0.008l14.826,33.115
		c-0.257,0.673-0.513,1.346-0.593,2.067C464.567,232.389,474.264,239.907,487.102,241.342z M196.993,321.587l0.545,0.272
		c-0.096,0.064-0.193,0.112-0.272,0.184C197.185,321.883,197.072,321.747,196.993,321.587z M176.012,368.821
		c-6.234,6.235-14.858,10.098-24.379,10.098c-9.52,0-18.144-3.863-24.379-10.098c-6.234-6.315-10.082-14.85-10.082-24.371
		c0-9.6,3.847-18.135,10.082-24.459c6.235-6.234,14.858-10.089,24.379-10.089c9.521,0,18.144,3.854,24.379,10.089
		c4.424,4.52,7.63,10.098,9.104,16.413c-4.263,7.47-6.732,16.004-6.732,25.277c0,1.394,0.08,2.789,0.16,4.192
		C177.807,366.939,176.91,367.924,176.012,368.821z M253.636,386.059c-6.235,6.235-14.858,10.09-24.362,10.09
		c-9.521,0-18.144-3.854-24.379-10.09c-4.44-4.432-7.71-10.097-9.104-16.413c-0.657-2.548-0.994-5.257-0.994-7.966
		c0-6.315,1.651-12.142,4.68-17.23c0.737-1.474,1.715-2.877,2.869-4.183c0.738-1.066,1.651-2.052,2.549-2.958
		c6.234-6.315,14.858-10.098,24.379-10.098c9.505,0,18.127,3.783,24.362,10.098c6.236,6.236,10.098,14.77,10.098,24.371
		C263.734,371.202,259.871,379.817,253.636,386.059z M447.913,180.923L447.913,180.923l0.129,0.072L447.913,180.923z"
              />
            </g>
          </svg>
        </ParallaxLayer>

        {/* rest */}
        <ParallaxLayer offset={0} speed={0.1} style={{ zIndex: 3 }}>
          <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="97.000000pt"
            height="300.000000pt"
            viewBox="0 0 97.000000 300.000000"
            preserveAspectRatio="xMidYMid meet"
            className="mt-[100vh] ml-[40%]"
            style={{ transform: `rotate(${rotate * 720}deg)` }}
          >
            <metadata>
              Created by potrace 1.10, written by Peter Selinger 2001-2011
            </metadata>
            <g
              transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
              fill="currentColor"
              stroke="none"
            >
              <path
                d="M235 2861 c15 -43 99 -185 127 -216 10 -11 21 -31 25 -45 3 -14 9
-30 14 -35 4 -6 22 -49 39 -95 17 -47 34 -94 39 -105 5 -11 17 -50 27 -87 9
-38 20 -68 24 -68 3 0 6 -49 6 -109 -1 -102 -3 -111 -25 -135 -36 -38 -88 -32
-134 15 -36 38 -64 15 -32 -27 8 -10 15 -27 15 -36 0 -9 7 -24 16 -32 8 -9 12
-20 9 -26 -3 -6 0 -13 9 -16 9 -3 12 -12 9 -21 -4 -11 -2 -14 5 -9 8 5 10 2 6
-8 -3 -9 -2 -16 4 -16 12 0 26 -47 23 -74 -2 -11 2 -16 8 -12 6 4 9 1 5 -7 -3
-8 2 -21 10 -30 9 -9 16 -27 16 -40 0 -13 7 -44 16 -68 38 -108 56 -197 55
-274 -2 -166 -55 -250 -143 -225 -17 6 -34 7 -37 5 -2 -3 11 -36 29 -75 23
-45 38 -65 43 -57 6 8 7 6 3 -5 -3 -10 16 -61 45 -119 76 -152 249 -569 249
-598 0 -6 6 -11 13 -11 8 0 28 -22 46 -50 32 -49 52 -68 31 -31 -5 11 -10 30
-10 43 0 13 -6 34 -13 48 -43 82 -114 302 -132 410 -20 119 -3 271 32 284 19
8 47 -8 72 -40 l21 -27 0 25 c0 14 -9 47 -20 74 -10 27 -36 92 -56 144 -20 52
-43 108 -51 124 -22 43 -141 386 -167 481 -2 6 -7 21 -13 35 -14 34 -24 90
-16 90 3 0 22 -5 43 -11 46 -14 86 4 127 58 27 35 28 41 28 147 -1 105 -2 115
-36 191 -20 44 -47 107 -59 140 -35 91 -208 388 -256 440 -24 25 -53 64 -65
85 -29 51 -42 51 -24 1z m312 -688 c-4 -3 -7 0 -7 7 0 7 3 10 7 7 3 -4 3 -10
0 -14z"
              />
            </g>
          </svg>
        </ParallaxLayer>

        {/* honeybeef */}
        <ParallaxLayer
          offset={1}
          speed={0.2}
          className="flex justify-center items-center h-screen"
        >
          <video
            autoPlay
            loop
            muted
            className="w-[90vw] md:w-[50vw] max-w-[500px] mt-[20vh]"
            style={{ zIndex: 1 }}
          >
            <source src="/honey_beef.mov" type="video/mp4" />
          </video>
        </ParallaxLayer>

        {/* penis */}
        <ParallaxLayer offset={1} speed={30} style={{ zIndex: 3 }}>
          <p className="text-center">penis</p>
        </ParallaxLayer>

        {/* boner */}
        <ParallaxLayer
          offset={2}
          speed={0.1}
          style={{ zIndex: 3 }}
          className="flex justify-center items-center justify-center h-screen"
        >
          <a
            href="https://open.spotify.com/artist/3VSXuiSPO2p2Bc8D7eU8Z3"
            target="_blank"
            rel="noreferrer"
            className="btn btn-lg btn-secondary hover:btn-error transition duration-300 ease-in-out hover:scale-150"
          >
            Do NOT Click This
          </a>
        </ParallaxLayer>

        {/* boner */}
        <ParallaxLayer offset={2.95} speed={0.1} style={{ zIndex: 3 }}>
          <p className="text-center">boner</p>
        </ParallaxLayer>
      </Parallax>
    </>
  );
}

export default ParallaxImages;
